import { render, staticRenderFns } from "./termsAndCondition.vue?vue&type=template&id=bf325bda&scoped=true"
import script from "./termsAndCondition.vue?vue&type=script&lang=js"
export * from "./termsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./termsAndCondition.vue?vue&type=style&index=0&id=bf325bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf325bda",
  null
  
)

export default component.exports